"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../schema");
const value = schema_1.Schema.number()
    .expiration(31536000)
    .unit("g/L")
    .precision(1)
    .min(5)
    .max(90)
    .interpretation({ vocab: "ktx", code: "lab_albumin" })
    .tag({ vocab: "loinc", code: "1751-7", source: "synonym" })
    .tag({ vocab: "snomed", code: "26758005", source: "synonym" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
